import { create } from 'zustand'

type Reference =
  | wowaudit.GuildReference
  | wowaudit.CommunityReference
  | wowaudit.TeamReference
  | wowaudit.CharacterReference

type ReferenceStore = {
  getReference: <T extends Reference>(path?: string) => T | undefined
  references: Record<string, Reference>
  storeReferences: (references: Reference[]) => void
}

const storePrefetchedReferences = () => {
  const sources = [
    ...Object.values(window.prefetched_data || {}),
    ...(window.page_info?.user?.teamReferences ?? []),
    ...(window.page_info?.user?.teamReferences?.map(
      (teamReference) => teamReference.ownerReference,
    ) ?? []),
    ...(window.page_info?.user?.characterReferences ?? []),
  ]

  return sources.reduce((acc, source) => {
    acc[source.path] = source
    return acc
  }, {} as Record<string, Reference>)
}

const useReferenceStore = create<ReferenceStore>((set, get) => ({
  references: storePrefetchedReferences(),
  storeReferences: (references: Reference[]) =>
    set((state) => ({
      references: {
        ...state.references,
        ...references.reduce((acc, reference) => {
          acc[reference.path] = reference
          return acc
        }, {} as Record<string, Reference>),
      },
    })),
  getReference: <T extends Reference>(path?: string): T | undefined =>
    path ? (get().references[path] as T | undefined) : undefined,
}))

export default useReferenceStore
